export function SubIcon() {
    return (<svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        fill="none"
        viewBox="0 0 14 14"
      >
        <path
          stroke="#0767F4"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M1.75 11.083c0-1.288 1.567-2.333 3.5-2.333s3.5 1.045 3.5 2.333"
        ></path>
        <path
          fill="#0767F4"
          d="M10.583 9.333a.5.5 0 001 0h-1zm1-3.5a.5.5 0 10-1 0h1zm0 3.5v-3.5h-1v3.5h1z"
        ></path>
        <path
          fill="#0767F4"
          d="M9.333 7.083a.5.5 0 000 1v-1zm3.5 1a.5.5 0 100-1v1zm-3.5 0h3.5v-1h-3.5v1z"
        ></path>
        <path
          stroke="#0767F4"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M5.25 7a2.333 2.333 0 100-4.667A2.333 2.333 0 005.25 7z"
        ></path>
      </svg>)
}